// NPM imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Components Imports
import FormField from "../PricebookItemEditor/FormField";

// Actions Import
import PricebooksActions from "../../../actions/PricebooksActions";

// Destructuring
const { updateFormRowData } = PricebooksActions;

// Component
// eslint-disable-next-line react/prefer-stateless-function
class PricebookClauseEditor extends Component {
  // to populate default values of 4th screen in formRowData
  // componentDidMount() {
  //   const tempFormRowData = { ...this.props.formRowData };
  //   this.props.customJSON.forEach(item => {
  //     if (
  //       !Object.prototype.hasOwnProperty.call(this.props.formRowData, item.fld)
  //     ) {
  //       tempFormRowData[item.fld] = item.defaultVal;
  //     }
  //   });
  //   this.props.updateFormRowData(tempFormRowData);
  // }

  render() {
    const heading = this.props.isEdit
      ? `Update Clause association`
      : `Clause association`;
    return (
      <div className="pricingmethodwrapper-wrapper">
        <div className="pricingmethod-title">
          <span className="pricingmethodwrapper-header">{heading}</span>
          <span className="pricingmethodwrapper-subheader">
            For {this.props.pricingMethodData.product.name}
          </span>
        </div>

        <div className="flatpriceeditor-wrapper">
          {this.props.customJSON.map(field => (
            <FormField {...field} key={field.fld} {...this.props} />
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { pricingMethodData } = state.PricebookStore;
  return {
    pricingMethodData,
  };
};

const mapDispatchToProps = {
  updateFormRowData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricebookClauseEditor);

// export default PricebookClauseEditor;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookClauseEditor/PricebookClauseEditor.js